import {
    makeStyles 
} from '@mui/styles';
import {
    Box, 
    Typography
} from '@mui/material';
import {
    TypographyVariants, 
    TypographyWeights
} from '../../../figmaTheme';

type Props = {
    value: number,
    label: string,
    svg?: JSX.Element
};

const useStyles = makeStyles(() => ({
    dataBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FFF7C0',
        borderRadius: '16px',
        width: '327px',
        columnGap: '32px',
        overflow: 'hidden'
    },
    textBox: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px',
        padding: '24px 0 24px 24px'
    },
    value: {
        fontWeight: TypographyWeights.BOLD,
    }
}));

export const DataBox = ({
    value, label, svg 
}: Props): JSX.Element => {
    const classes = useStyles();

    return (
        <Box className={classes.dataBox}>
            <Box className={classes.textBox}>
                <Typography
                    variant={TypographyVariants.H2}
                    className={classes.value}
                >
                    {value}
                </Typography>
                <Typography
                    variant={TypographyVariants.H6}
                >
                    {label}
                </Typography>
            </Box>
            <Box>
                {svg}
            </Box>
        </Box>
    );
};

export default DataBox;
